var sidebar = {
    toggle: function (event, side) {
        event.preventDefault()

        var className = 'show-' + side + '-sidebar',
            body = document.body

        if (body.classList.contains(className)) {
            body.classList.remove(className)
        } else {
            body.classList.add(className)
        }
    }
}

function previewProductImage(url) {
    var previewModalDom = document.querySelector('#preview-image-modal')
    if (! previewModalDom) {
        return false
    }

    var previewModal = new bootstrap.Modal(previewModalDom, {
        keyboard: true
    })

    previewModalDom.querySelector('.image-frame').innerHTML = '<img src="' + url + '" class="mw-100 mh-100" />'

    previewModal.show()
}
